import {
	IGetDeviceInfo,
	ICreateDevice,
	IEditDevice,
	IGetPaginatedDevices,
	IDevices,
	IDeviceNotificationsData,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetDeviceInfo = (deviceID: string): Promise<IGetDeviceInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Devices/${deviceID}` });
};

const serviceCreateDevice = (data: ICreateDevice): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Devices`, data });
};

const serviceUpdateDevice = (data: IEditDevice): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Devices/${data.id}`, data });
};

const serviceGetPaginatedDevices = (args: IGetPaginatedDevices): Promise<AxiosResponse<IDevices>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Devices/filtered`, data: args });
};

const serviceDeleteDevice = (deviceID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Devices/${deviceID}` });
};

const servicePushDeviceNotifications = (
	hardwareID: string,
	data: IDeviceNotificationsData,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v1/devices/${hardwareID}/push-notifications:register`,
		data,
	});
};

export {
	serviceGetDeviceInfo,
	serviceCreateDevice,
	serviceUpdateDevice,
	serviceGetPaginatedDevices,
	serviceDeleteDevice,
	servicePushDeviceNotifications,
};
